(function($, once, Drupal) {
  Drupal.behaviors.user_form = {
    attach(context) {
      const minPasswordLength = 8;
      const passwordField = once(
        'validate',
        '.js-password-field',
        context
      );
      const passwordConfirmField = once(
        'validate',
        '.js-password-confirm',
        context
      );
      const formSubmit = once(
        'validate',
        '.js-form-submit',
        context
      );
      const emailConfirmField = once(
        'validate',
        '.js-email-confirm',
        context
      );
      const $passwordField = $(passwordField);
      const $passwordConfirmField = $(passwordConfirmField);
      const $formSubmit = $(formSubmit);
      const $emailConfirmField = $(emailConfirmField);
      const formStep  = drupalSettings.form_step ? drupalSettings.form_step : null;
      let passwordIsValid, passwordConfirmationIsValid  = '';

      if (formStep === 'account_creation') {
        passwordIsValid = () => $passwordField.val().length >= minPasswordLength;
        passwordConfirmationIsValid = () => $passwordConfirmField.val() === $passwordField.val();
      }
      const fields = new Map();
      fields.set('passwordField', { $elem: $passwordField, message: `Your password should contain 8 characters`});
      fields.set('passwordConfirmField', { $elem: $passwordConfirmField, message: `Your passwords do not match`});
      const animationDuration = 6; // tenths of a second
      const animationDurationMs = animationDuration * 100; //milliseconds
      function showError ({$elem, message}) {
        if ( $elem.siblings('.form-item--error-message').length === 0 ) {
          const $parent = $elem
              .addClass('error')
              .parent();
          $(`<div>${message}</div>`)
            .addClass('form-item--error-message')
            .css({
              opacity: '0',
              height: '0',
            })
            .appendTo($parent)
            .animate(
              {
                opacity: '1',
                height: '100%',
              },
              animationDurationMs
            );
        }
      }
      function removeError ($field) {
        $field
          .removeClass('error')
          .siblings('.form-item--error-message')
          .animate(
            {
              opacity: '0',
              height: '0',
            },
            'fast',
            function () {
              $(this).remove();
            }
          );
      }
      function scrollAndShake () {
        console.log('scrollAndShake');
      }
      function addShowHideAnimation ($field) {
        const transition = `all .${animationDuration}s ease-in-out`;
        setTimeout(function () {
          $field
            .parent()
            .css({ transition });
        }, animationDurationMs);
      }
      if (passwordField.length > 0) {
        addShowHideAnimation($passwordField);
        $passwordField
          .on(
            'change',
            function () {
              if (!passwordIsValid()) {
                showError(fields.get('passwordField'));
              }
              if ($passwordConfirmField.val().length > 0 && ($passwordConfirmField.val() !== $passwordField.val())) {
                showError(fields.get('passwordConfirmField'));
              }
            }
          )
          .on(
            'keyup',
            function () {
              if (passwordIsValid()) {
                removeError($passwordField);
              }
              if (passwordConfirmationIsValid()) {
                removeError($passwordConfirmField);
              }
            }
          );
      }
      if (passwordConfirmField.length > 0) {
        addShowHideAnimation($passwordConfirmField);
        $passwordConfirmField
          .on(
            'change',
            function () {
              if (!passwordConfirmationIsValid()) {
                showError(fields.get('passwordConfirmField'));
              }
            }
          )
          .on(
            'keyup',
            function () {
              if (passwordConfirmationIsValid()) {
                removeError($passwordConfirmField);
              }
            }
          );
      }
      if (formSubmit.length > 0) {
        $formSubmit
          .on(
            'click',
            function (event) {
              //Triggers only on the account creation form
              if (formStep === 1) {
                let invalid = false;
                if (!passwordIsValid()) {
                  invalid = true;
                  showError(fields.get('passwordField'));
                }
                if (!passwordConfirmationIsValid()) {
                  invalid = true;
                  showError(fields.get('passwordConfirmField'));
                }
                if (invalid) {
                  event.preventDefault();
                  scrollAndShake();
                }
              }
            }
          );
      }
      if (emailConfirmField.length > 0) {
        addShowHideAnimation($emailConfirmField);
      }
    }
  };
})(jQuery, once, Drupal);
